<app-modal-wrapper [staticHeight]="staticHeight" [modal]="modal">
  <ng-container>

    <app-page-header [title]="'Реквизиты карты'" [backBtn]="false" [closeModalBtn]="false"></app-page-header>
    <div class="card-requisites-content">
            <div class="copy-item">
                <span class="value">{{ product.cardNumber | masked: cardMask }}</span>
                <ion-icon name="custom-copy" aria-hidden="true" (click)="copyInfo(product.cardNumber, 'cardNumber')"></ion-icon>
            </div>
            <div class="copy-item">
                <span class="value">{{ product.expire }}</span>
                <ion-icon name="custom-copy" aria-hidden="true" (click)="copyInfo(product.expire, 'date')"></ion-icon>
            </div>
    </div>
  </ng-container>

  <ion-footer class="ion-no-border" footer>
      <ion-button class="button block primary shadow"
                  mode="ios"
                  expand="block" (click)="sendCvv()">Получить CVV по SMS</ion-button>
    </ion-footer>
</app-modal-wrapper>
